module.exports = __webpack_public_path__ + "img/car-insurance.d05cfcd.svg";